import {createFeatureSelector, createSelector} from '@ngrx/store';
import {State} from './organization-account.production-instance-types.reducer';
import {InstanceType} from '../../../services/api/account/instance-types/instance-type.model';

export const loadProductionInstanceTypesFeatureKey = 'productionInstanceTypes';
export const getProductionInstanceTypesSelector = createFeatureSelector<State>(loadProductionInstanceTypesFeatureKey);

export const getProductionInstanceTypes = createSelector(
  getProductionInstanceTypesSelector,
  (state: State): InstanceType[] => state.record
);

export const getProductionInstanceTypesLoaded = createSelector(
  getProductionInstanceTypesSelector,
  (state: State): boolean => state.loaded
);

export const getProductionInstanceTypesLoading = createSelector(
  getProductionInstanceTypesSelector,
  (state: State): boolean => state.loading
);

export const getProductionInstanceTypesError = createSelector(
  getProductionInstanceTypesSelector,
  (state: State): any => state.error
);
